<template>
  <div class="internationality">
<!--    多语言使用方法  1.添加引用  添加
import internationality from '@/components/internationality'
2.添加组件
 components:{
    internationality
  },
3.在需要的位置添加标签
 <internationality keyword='123' type='editor' ></internationality>
  <internationality keyword='123' type='image' ></internationality>
   <internationality keyword='123' type='string' ></internationality>

    <internationality v-if="windowAddItem.id" :keyword="'activity_type|type_name|'+windowAddItem.id" type='string' ></internationality>

-->
    <Button type="primary" @click="showModleFun">{{$t('多语言')}}</Button>
    <!-- @on-visible-change="visibleChange" -->
    <Modal
      v-model="showModal"
      title="编辑框"
      ok-text="确定"
      cancel-text="取消"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <Form ref="ModalForm" :model="fromData" :label-width="100" label-position="left">


        <FormItem v-if="type!='undefined'&&type=='image'" v-for="item in list" :key="item.table_suffix"
                  :label="item.country" :prop="item.table_suffix">

          <div class="demo-upload-list" v-if="fromData[item.table_suffix]">
            <img :src="fromData[item.table_suffix]" style="max-width: 200px;max-height: 200px">
            <div class="demo-upload-list-cover">
              <Icon type="ios-trash-outline" @click.native="handleImgRemove(item.table_suffix)"></Icon>
            </div>
          </div>
          <input v-if="fromData[item.table_suffix]" v-model="fromData[item.table_suffix]" type="hidden" name="image">

          <Upload type="drag"
                  :action="uploadUrl"
                  :headers="uploadHeader"
                  v-if="!fromData[item.table_suffix]"
                  :format="['jpg','jpeg','png','gif']"
                  :max-size="5120"
                  :data="{key:item.table_suffix}"
                  :on-success="handleImgSuccess"
                  :on-format-error="handleImgFormatError"
                  :on-exceeded-size="handleImgMaxSize"
                  style="display: inline-block;width:58px">
            <div style="width: 58px;height:58px;line-height: 58px">
              <Icon type="md-camera" size="20"></Icon>
            </div>
          </Upload>

        </FormItem>


        <FormItem v-if="type!='editor'&&type!='image'" v-for="item in list" :key="item.table_suffix"
                  :label="item.country" :prop="item.table_suffix">
          <Input v-model="fromData[item.table_suffix]" size="large" type="textarea" clearable></Input>
        </FormItem>


        <FormItem v-if="type!='undefined'&&type=='editor'" style="margin-bottom:4px" v-for="item in list"
                  :key="item.table_suffix" :label="item.country"
                  :prop="item.table_suffix">
          <div>
            <textarea :name="item.table_suffix" id="ck-editor" rows="10" cols="80"></textarea>
          </div>
        </FormItem>


      </Form>
    </Modal>
  </div>
</template>

<script>
import CKEDITOR from 'CKEDITOR'

import {
  getInternationality,
  postInternationality,
} from '@/components/internationality/station.js'
import { baseUrl } from '@/libs/api.request'
import { getToken } from '@/libs/util'

export default {
  name: 'internationality',

  data () {
    return {
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: { 'Api-Auth': getToken() },
      showModal: false,
      editor: [],
      fromData: {
        'zh-cn': '',
        'en-us': '',
        'ru-ru': '',
        'en-ph': '',
        'ko-kr': '',
        'ms-my': '',
        'pt-pt': '',
        'tr-tr': '',
        'es-es': '',
        'gu-in': '',
        'id-id': '',
        'vi-vn': '',
        'th-th': '',
        'ar-sa': '',
      },
      isEditorOk: false,
      list: [],
    }
  },
  props: {
    keyword: {
      type: String,
      required: true,
    },
    type: { //image  edit  还有其它
      type: String,
      required: true,
    },
  },
  computed: {},
  watch: {},
  mounted () {

  },
  methods: {
    initializeEditor () {
      //循环 生成编辑框,并写入默认值,添加延时,让其在渲染后再显示
      var that = this
      setTimeout(function () {
        if (that.isEditorOk) {
          for (var key in that.list) {
            //设置值
            that.editor[that.list[key]['table_suffix']].setData(that.list[key]['content'])
          }
          return
        }
        for (var key in that.list) {
          that.isEditorOk = true
          try {
            that.editor[that.list[key]['table_suffix']] = CKEDITOR.replace(that.list[key]['table_suffix'], {
              language: 'zh-CN',      // Adding drag and drop image upload.
              removeDialogTabs: 'image:advanced;image:Link',
              image_previewText: '  ',
              extraPlugins: 'uploadimage',
              uploadUrl: this.uploadUrlCk,
              filebrowserImageUploadUrl: this.uploadUrlCk,
              filebrowserUploadUrl: this.uploadUrlCk, //服务器上传地址
              removeButtons: 'Save,PasteFromWord,PasteText,Paste,Copy,Replace,Scayt,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,BulletedList,NumberedList,Indent,Outdent,Language,About,ShowBlocks,Flash,Anchor,HorizontalRule,PageBreak,Iframe'
            })
            that.editor[that.list[key]['table_suffix']].on('fileUploadResponse', function (evt) {   // 图片上传返回的数据处理
              evt.stop()
              var data = evt.data
              let xhr = data.fileLoader.xhr
              let response = xhr.responseText
              let imgUrl = JSON.parse(response).data.fileUrl
              if (!imgUrl) {
                data.message = '上传出错'   // 这是失败alert提示信息
                evt.cancel()
              } else {
                data.url = imgUrl   // 返回到“图像信息”那里的URL框里面
              }
            })
          } catch (e) {
            that.isEditorOk = false
          }

          //设置值
          that.editor[that.list[key]['table_suffix']].setData(that.list[key]['content'])

        }

      }, 250)

    },
    // 获取
    getWzbt () {
      getInternationality({ label: this.keyword, type: this.type }).then((response) => {

        if (response.data.code == 1) {
          this.list = response.data.data
          for (var key in this.list) {
            this.fromData[this.list[key]['table_suffix']] = this.list[key]['content']
          }
          if (this.type == 'editor') {
            this.initializeEditor()
          }

          if (this.type == 'editor') {//如果是编辑框,则手动添加数据到fromData
            for (var key in this.list) {
              //设置值
              this.editor[this.list[key]['table_suffix']].setData(this.list[key]['content'])
            }
          }

        } else {
          this.$Message.error(response.data.data.msg)
        }
      })
    },

    // 提交
    postWzbt () {
      if (this.type == 'editor') {//如果是编辑框,则手动添加数据到fromData
        for (var key in this.list) {
          //设置值
          this.fromData[this.list[key]['table_suffix']] = this.editor[this.list[key]['table_suffix']].getData()
        }
      }

      let params = {
        ...this.fromData,
        ...{ label: this.keyword },
      }
      postInternationality(params).then((response) => {
        console.log(response)

      })
    },

    showModleFun () {
      this.showModal = true
      this.getWzbt()

    },

    ok () {
      this.postWzbt()
      //   this.$emit('clickedOk',this.fromData);
    },

    cancel () {
    },

    handleImgFormatError (file) {
      this.$Notice.warning({
        title: '文件类型不合法',
        desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
      })
    },
    handleImgRemove (key) {
      this.fromData[key] = ''
      console.log(this.fromData)
    },
    handleImgSuccess (response) {
      console.log(response)
      if (response.code === 1) {
        this.$Message.success(response.msg)

        if (response.data.key) {
          this.fromData[response.data.key] = response.data.fileUrl
        } else {
          this.fromData.logo = response.data.fileUrl
        }

        //由于字段是动态的，所以查找一下 图片字段，再显示
        // for (let key in this.windowAdd.windowsParams2) {
        //   if (this.windowAdd.windowsParams2[key]['type'] == 'image') {
        //     this.windowAddItem[key] = response.data.fileUrl
        //   }
        // }
      } else {
        this.$Message.error(response.msg)
      }
    },
    handleImgMaxSize (file) {
      this.$Notice.warning({
        title: '文件大小不合法',
        desc: file.name + '太大啦请上传小于5M的文件。'
      })
    },

    // visibleChange(e) {
    //   if (e) this.$refs["ModalForm"].resetFields();
    // },
  },

}
</script>

<style lang="less" scoped>
.internationality {
  display: inline-block;
  vertical-align: middle;
  margin-left: 15px;
}
</style>
